import { useLayoutEffect } from 'react';
import { usePageLayoutStore, IPageLayoutProps } from '@diana/core';
import { ConfigureEditorDrawerHeader } from './ConfigureEditorDrawerHeader';
import { ConfigureEditorDrawerContent } from './ConfigureEditorDrawerContent';
import { useFlowBuilder2PageStore } from '../../Store/useFlowBuilder2PageStore';

export const useConfigureEditorDrawer = (): NonNullable<IPageLayoutProps['rightDrawer']> => {
  const isRightDrawerOpen = usePageLayoutStore((s) => s.isRightDrawerOpen);
  const setIsRightDrawerOpen = usePageLayoutStore((s) => s.setIsRightDrawerOpen);
  const setIsRightDrawerPersistent = usePageLayoutStore((s) => s.setIsRightDrawerPersistent);
  const isRightDynamicDrawerActive = usePageLayoutStore((s) => !!s.dynamicRightDrawer);
  const setDynamicRightDrawer = usePageLayoutStore((s) => s.setDynamicRightDrawer);

  const activeComponent = useFlowBuilder2PageStore((s) => s.activeComponent);
  const activeTaskId = useFlowBuilder2PageStore((s) => s.activeTaskId);

  // when the active component or task changes, close the dynamic drawer and open the configure editor drawer
  useLayoutEffect(() => {
    if (isRightDynamicDrawerActive) {
      setDynamicRightDrawer(null);
      setIsRightDrawerOpen(true);
      setIsRightDrawerPersistent(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeComponent, activeTaskId]);

  // when the dynamic drawer is closed, ensure the configure editor drawer is open
  useLayoutEffect(() => {
    if (!isRightDynamicDrawerActive && !isRightDrawerOpen) {
      setIsRightDrawerOpen(true);
      setIsRightDrawerPersistent(true);
    }
  }, [
    isRightDrawerOpen,
    isRightDynamicDrawerActive,
    setIsRightDrawerOpen,
    setIsRightDrawerPersistent,
  ]);

  return {
    isOpen: true,
    persistent: true,
    resizable: true,
    header: <ConfigureEditorDrawerHeader />,
    content: <ConfigureEditorDrawerContent />,
  };
};
